module.exports = __webpack_public_path__ + "static/media/logo_horizontal.77ff6f7b.png";